import { BasicInformationInputInitialValues, FreeChatInputInitialValues, ChatInputInitialValues } from '../utils/formik/initialValues';
import API from '@aws-amplify/api'
import { API_NAME } from '../const';
import { checkCurrentAuthenticatedUser } from 'utils/currentAuthenticatedUserChecker'

export interface UpdateBasicInformationResponse {
  status: string
  data: string | null
}

export async function updateBasicInformation(applyId: string, data: BasicInformationInputInitialValues): Promise<UpdateBasicInformationResponse> {
  await checkCurrentAuthenticatedUser()
  if (!data.callFlg) {
    data.callDesignatedDate = null
    data.callDesignatedTimeAndMemo = null
  }
  const response = await API
    .put(API_NAME, `/v2/` + applyId, {
      body: {
        memoAD: data.memoAD,
        memoSV: data.memoSV,
        isSmsSendingRequired: data.isSmsSendingRequired,
        responseStatus: data.responseStatus,
        policyNumberRevised: data.policyNumberRevised,
        nameRevised: data.nameRevised,
        nameKanaRevised: data.nameKanaRevised,
        memo: data.memo,
        isIdentifiedAll: data.isIdentifiedAll,
        callFlg: data.callFlg,
        callDesignatedDate: data.callDesignatedDate,
        callDesignatedTimeAndMemo: data.callDesignatedTimeAndMemo,
        callHistories: data.callHistories,
      }
    })
    .catch((err) => {
      console.error(err);
      return {
        data: {
          status: 'fail'
        }
      };
    });
  return response;
}

export interface SendChatLineMessageResponse {
  status: string
  data: string | null
}
interface SendChatLineMessagePostData extends ChatInputInitialValues {
  applyId: string
  changeDate: string | null
  afterCurrentPurpose: number | null
  driverLicenseColorOfYoungest: number | null
  forBusinessUseCar: number | null
  genderOfYoungest: number | null
  name: string
  policyNumber: string
  detailNumber: string
  receptionDatetime: string
}

export async function sendChatLineMessage(data: SendChatLineMessagePostData): Promise<SendChatLineMessageResponse> {
  await checkCurrentAuthenticatedUser()
  const response = await API
    .post(API_NAME, `/v2/line/acceptance-url`, {
      body: {
        data: { ...data }
      }
    })
    .catch((err) => {
      console.error(err);
      return {
        data: {
          status: 'fail',
          // shouldDisplayMessageがtrueで返ってきた時は、エラーメッセージを呼び出し元に返したいので、dataに格納
          data: err.response && err.response.data && err.response.data.shouldDisplayMessage && err.response.data.data,
        }
      };
    });
  return response;
}

export interface SendFreeChatLineMessageResponse {
  status: string
  data: string | null
}

export async function sendFreeChatLineMessage(applyId: string, data: FreeChatInputInitialValues): Promise<SendFreeChatLineMessageResponse> {
  await checkCurrentAuthenticatedUser()
  const response = await API
    .post(API_NAME, `/v2/line/freechat`, {
      body: {
        data: { ...data, applyId }
      }
    })
    .catch((err) => {
      console.error(err);
      return {
        data: {
          status: 'fail'
        }
      };
    });
  return response;
}
